<template>
  <div
    class="toggle"
    :class="{ checked: modelValue }"
    @click.stop="toggle"
  >
    <div class="circle" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: Boolean
})

const emit = defineEmits(['update:modelValue'])

const toggle = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped>
.toggle {
  width: 41px;
  height: 24px;
  border-radius: 12px;
  background-color: #C5D2E6;
  display: flex;
  align-items: center;
  padding: 2px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.toggle .circle {
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.toggle.checked {
  background-color: #002C5F;
}

.toggle.checked .circle {
  transform: translateX(17px);
}
</style>
